import React, { useState } from "react";
import { connect } from "react-redux";
import CustomCarousel from "../../../components/CustomCarousel/CustomCarousel";
import Spinner from "../../../components/Common/Spinner";
import { useHistory } from "react-router-dom";
import {
  DashboardStyles,
  DashboardButtonsContainer,
  ModalOptionsButtonsContainer,
} from "../styles/DashboardStyles";
import CustomLayout from "../../../components/CustomLayout/CustomLayout";
import CustomModal from "../../../components/CustomModal/CustomModal";
import { Section } from "../../../components/CustomLayout/CustomLayoutStyles";
import CustomButton from "../../../components/CustomButton/CustomButton";
import TittleLine from "../../../components/Common/TittleLine";
import useEmpresa from "../../../hooks/useEmpresa";
import CustomSeparator from "../../../components/Common/CustomSeparator";
import DashboardDisclaimer from "../components/DashboardDisclaimer";
import AutorizacionDiagnostico from "../../autorizacion/components/AutorizacionDiagnostico";
import CheckRender from "../../../components/Common/CheckRender";
import { getStandVirtualFullUrl } from "../../autorizacion/utils/AutorizacionUtils";
import { EMPRESA, PROGRAMA } from "../../../utils/Constant";

const DashboardScreen = (props) => {
  const {
    prestador,
    isStandVirtual,
    tokenStandVirtual,
    configuracionPaperFree,
  } = props?.authUserData;

  const history = useHistory();

  const empresa = useEmpresa();

  const isPrimera = empresa?.CODIGO === EMPRESA.PRIMERA.CODIGO;

  const [showModalPrecertificacion, setShowModalPrecertificacion] =
    useState(false);

  const [showModalCierreCuentas, setShowModalCierreCuentas] = useState(false);

  const goTo = (screen) => {
    history.push(screen);
  };

  const goToStandVirtual = () => {
    const newTab = window.open(
      getStandVirtualFullUrl(tokenStandVirtual),
      "_blank"
    );

    newTab.focus();
  };

  return (
    <CustomLayout>
      <CustomSeparator height={"20px"} />

      <Section>
        <DashboardDisclaimer
          title={`¡Hola ${prestador?.nombre}!`}
          text={
            "Realiza las consultas y solicitudes de las autorizaciones en línea."
          }
        />
      </Section>

      <CustomSeparator height={"30px"} />

      <Section>
        <TittleLine title={"Autorizaciones en línea"} weight={"bold"} />
      </Section>

      <Section>
        <DashboardButtonsContainer>
          <CustomButton
            label={"Solicitar Autorización"}
            isLoading={false}
            width={DashboardStyles.homeButtonWidth}
            height={"auto"}
            weight={"bold"}
            onClick={() => {
              goTo("/autorizacion");
            }}
          />
          <CustomSeparator width={"10px"} />
          <CustomButton
            label={"Búsqueda Avanzada"}
            isLoading={false}
            width={DashboardStyles.homeButtonWidth}
            height={"auto"}
            weight={"bold"}
            onClick={() => {
              goTo("/busqueda-autorizacion");
            }}
          />
          <CustomSeparator width={"10px"} />
          <CustomButton
            label={"Precertificaciones"}
            isLoading={false}
            width={DashboardStyles.homeButtonWidth}
            height={"auto"}
            weight={"bold"}
            onClick={() => {
              setShowModalPrecertificacion(true);
            }}
          />
          <CheckRender allowed={isPrimera && prestador?.permiteCierreCuenta}>
            <CustomSeparator width={"10px"} />
            <CustomButton
              label={"Cierre de cuentas clínicas"}
              isLoading={false}
              width={DashboardStyles.homeButtonWidth}
              height={"auto"}
              weight={"bold"}
              onClick={() => {
                setShowModalCierreCuentas(true);
              }}
            />
          </CheckRender>
          <CheckRender allowed={isStandVirtual}>
            <CustomSeparator width={"10px"} />
            <CustomButton
              label={"Stand Virtual"}
              isLoading={false}
              width={DashboardStyles.homeButtonWidth}
              height={"auto"}
              weight={"bold"}
              onClick={goToStandVirtual}
            />
          </CheckRender>
          <CheckRender allowed={prestador.pyp && isPrimera}>
            <CustomSeparator width={"10px"} />
            <CustomButton
              label={PROGRAMA.PROMOCION_PREVENCION.DESCRIPCION}
              isLoading={false}
              width={DashboardStyles.homeButtonWidth}
              weight={"bold"}
              height={"auto"}
              onClick={() => {
                window.location.href =
                  "/autorizacion?program=" +
                  PROGRAMA.PROMOCION_PREVENCION.CODIGO;
              }}
            />
          </CheckRender>
          <CheckRender allowed={prestador.cronicoComplejo && isPrimera}>
            <CustomSeparator width={"10px"} />
            <CustomButton
              label={PROGRAMA.CRONICO_COMPLEJO.DESCRIPCION}
              isLoading={false}
              width={DashboardStyles.homeButtonWidth}
              weight={"bold"}
              height={"auto"}
              onClick={() => {
                window.location.href =
                  "/autorizacion?program=" +
                  PROGRAMA.CRONICO_COMPLEJO.CODIGO;
              }}
            />
          </CheckRender>
        </DashboardButtonsContainer>
      </Section>

      <CustomSeparator height={"50px"} />

      <CheckRender allowed={props.getAutorizacionesDiagnosticoLoading}>
        <Spinner size={20} colorBorderTop={empresa?.COLOR_PRINCIPAL} />
      </CheckRender>

      <CheckRender allowed={configuracionPaperFree?.esPaperFree}>
        <Section>
          <AutorizacionDiagnostico />
        </Section>
        <CustomSeparator height={"70px"} />
      </CheckRender>

      <Section>
        <CustomCarousel images={empresa?.CAROUSEL} />
      </Section>

      <CustomModal
        isOpen={showModalPrecertificacion}
        onClose={() => {
          setShowModalPrecertificacion(false);
        }}
      >
        <ModalOptionsButtonsContainer>
          <CustomButton
            label={"Confirmar Precertificación"}
            isLoading={false}
            width={DashboardStyles.homeButtonWidth}
            weight={"bold"}
            onClick={() => {
              goTo("/confirmar-precertificacion");
            }}
          />
          <CustomSeparator width={"10px"} />
          <CustomButton
            label={"Cancelar Precertificación"}
            isLoading={false}
            width={DashboardStyles.homeButtonWidth}
            weight={"bold"}
            onClick={() => {
              goTo("/cancelar-precertificacion");
            }}
          />
        </ModalOptionsButtonsContainer>
      </CustomModal>

      <CustomModal
        isOpen={showModalCierreCuentas}
        onClose={() => {
          setShowModalCierreCuentas(false);
        }}
      >
        <ModalOptionsButtonsContainer>
          <CustomButton
            label={"Realizar cierre de cuenta"}
            isLoading={false}
            width={DashboardStyles.homeButtonWidth}
            weight={"bold"}
            onClick={() => {
              goTo("/cierre-cuentas");
            }}
          />
          <CustomSeparator width={"10px"} />
          <CustomButton
            label={"Búsqueda avanzada"}
            isLoading={false}
            width={DashboardStyles.homeButtonWidth}
            weight={"bold"}
            onClick={() => {
              goTo("/busqueda-cierres-cuentas");
            }}
          />
        </ModalOptionsButtonsContainer>
      </CustomModal>
    </CustomLayout>
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  authUserLoading: state.auth.authUserLoading,
  authUserError: state.auth.authUserError,

  getAutorizacionesDiagnosticoLoading:
    state.autorizacion.getAutorizacionesDiagnosticoLoading,

  formAutorizacionDiagnosticoData:
    state.autorizacion.formAutorizacionDiagnosticoData,
});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(DashboardScreen);
